module.exports = __webpack_public_path__ + "media/app/images/success_launch@2x-c2d6f4ce13960742485edb598f2fa656.png";